





















































import type { PropType } from "vue"
import type { stadium_business_increase } from "@/@types/stadium/stadium"
import { Vue } from "vue-property-decorator"
import moment from "moment"

export default Vue.extend({
  name: "StadiumBusinessForm",
  props: {
    id      : { type: String, required: true },
    button  : { type: Boolean, default: true },
    editable: { type: Boolean, required: true },
    form    : { type: Object as PropType<stadium_business_increase> },
    correct : { type: Object, default() { return {} } },
    show    : { type: Object,
      default() {
        return {
          all                   : true,
          business_time_new     : true,
          business_time_new_hour: true
        }
      }
    },
  },
  data() {
    return {
      data       : {} as stadium_business_increase,
      change     : {} as any,
      change_time: [] as [][],
      times      : [
        {
          start: null as moment.Moment | null,
          end  : null as moment.Moment | null,
          days : [] as string[]
        },
      ],
      days: [
        { label: "周一", value: "1" },
        { label: "周二", value: "2" },
        { label: "周三", value: "3" },
        { label: "周四", value: "4" },
        { label: "周五", value: "5" },
        { label: "周六", value: "6" },
        { label: "周日", value: "0" },
      ]
    }
  },
  computed: {
    if_correct() {
      return (key: string): string => {
        let is_correct = ""
        if (Object.prototype.hasOwnProperty.call(this.form, key) && Object.prototype.hasOwnProperty.call(this.correct, key)) {
          if (this.correct.id && this.correct.id > 0) is_correct = ""
          else is_correct = "is_correct"
        }
        return is_correct
      }
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        const data = this.$deep_copy(this.form)
        if (data.business_time_new && data.business_time_new.length > 0) {
          this.times = []
          for (const time of data.business_time_new) {
            const temp = time.split(",")
            const t    = temp[0].split("-")
            delete temp[0]
            this.times.push({ start: moment(t[0], "HH:mm"), end: moment(t[1], "HH:mm"), days: temp })
          }
        }
        this.data = data
        if (Object.prototype.hasOwnProperty.call(this.correct, "business_time_new")) {
          for (const v of this.correct.business_time_new) {
              const temp = v.split(",")
              this.change_time.push(temp)
            }
        }
      })
    },
    show_correct(key: string): boolean {
      let correct = false
      if (Object.prototype.hasOwnProperty.call(this.form, key) && Object.prototype.hasOwnProperty.call(this.correct, key)) {
        if (this.correct.id && this.correct.id > 0) correct = true
        else correct = false
      }
      return correct
    },
  }
})

